import React, { useRef } from 'react';
import styles from './ThemeImportExport.module.css';

interface ThemeImportExportProps {
  themeConfig: any;
  onImport: (config: any) => void;
  versionId?: string;
}

export const ThemeImportExport: React.FC<ThemeImportExportProps> = ({
  themeConfig,
  onImport,
  versionId,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleExport = () => {
    const dataStr = JSON.stringify(themeConfig, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `theme-${versionId || 'config'}-${Date.now()}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleImportClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const config = JSON.parse(event.target?.result as string);
        onImport(config);
      } catch (err) {
        alert('Invalid JSON file. Please check the file format.');
      }
    };
    reader.readAsText(file);

    // Reset input
    e.target.value = '';
  };

  return (
    <div className={styles.importExport}>
      <button
        type="button"
        onClick={handleExport}
        className={styles.exportButton}
      >
        📥 Export Configuration
      </button>
      <button
        type="button"
        onClick={handleImportClick}
        className={styles.importButton}
      >
        📤 Import Configuration
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        onChange={handleFileChange}
        className={styles.fileInput}
      />
    </div>
  );
};
